import { SITE_NAME } from "./seo";

/**
 * 专题 SEO 落地页（非城市维度）
 * meta / JSON-LD 含目标关键词；页面正文保持中性表述。
 */
export const TOPIC_SEO_LIST = [
  {
    slug: "zhuxin",
    badge: "共同价值观",
    headline: "共同价值观 · 严肃婚恋找对象",
    intro:
      "寻找价值观一致、以结婚为目的的对象？AI婚恋平台按资料与测评推荐合适的异性会员，并提供专业咨询师免费陪伴，从相识、交往到结婚全程辅导。",
    keywords:
      "共同价值观,价值观匹配,严肃婚恋,以结婚为目的的交友,找对象,脱单相亲,同城找对象,婚恋咨询,婚恋交友",
    metaDescription:
      "共同价值观与严肃婚恋找对象：以结婚为目的，AI智能匹配异性，专业婚恋咨询师前期免费陪伴，从认识到结婚全程辅导，区别于传统红娘介绍。",
    ogDescription: "共同价值观匹配与找对象服务，AI匹配 + 咨询师免费陪伴。",
    features: [
      {
        title: "价值观匹配",
        text: "按资料与测评推荐合适的异性会员，认证用户优先展示。",
      },
      {
        title: "咨询师陪伴",
        text: "前期免费一对一陪伴，帮助你在交往中更稳妥地走向婚姻。",
      },
      {
        title: "严肃婚恋",
        text: "以结婚为目的，支持恋爱指导与婚前辅导咨询。",
      },
    ],
    faqs: [
      {
        q: "强调共同价值观和普通相亲有什么不同？",
        a: "平台更看重长期契合与相处方式，咨询师会从交往过程入手辅导，而非仅做一次介绍。",
      },
      {
        q: "如何开始？",
        a: "免费注册并完善资料，完成 AI 测评后即可查看推荐对象，并可预约咨询师。",
      },
    ],
    primaryCta: { label: "免费注册 · 开始找对象", to: "/register" },
    secondaryCta: { label: "查看推荐会员", to: "/discover" },
    tertiaryCta: { label: "了解咨询师", to: "/consultants" },
    jsonLdTopics: ["共同价值观", "严肃婚恋", "找对象"],
  },
  {
    slug: "tuodan",
    badge: "脱单相亲",
    headline: "脱单 · 同城相亲找对象",
    intro:
      "想认真脱单、以结婚为目的交往？AI婚恋平台提供同城智能匹配与咨询师免费陪伴，支持按城市、年龄等筛选，帮助你在同城范围内找到合适的对象。",
    keywords:
      "脱单,相亲,找对象,征婚,同城相亲,同城脱单,严肃婚恋,以结婚为目的的交友,免费相亲,在线相亲,婚恋交友,相亲平台,婚恋咨询,婚姻咨询",
    metaDescription:
      "脱单相亲找对象：全国同城严肃婚恋，免费注册，AI智能匹配推荐异性，专业咨询师免费陪伴，支持按城市筛选脱单征婚，从相识恋爱到结婚全程辅导。",
    ogDescription: "同城脱单相亲与找对象，AI匹配 + 咨询师陪伴 + 婚恋咨询。",
    features: [
      {
        title: "同城匹配",
        text: "按所在城市与条件筛选，优先推荐认证、最近活跃的会员。",
      },
      {
        title: "AI 推荐",
        text: "完成测评后获得智能异性推荐，减少盲目浏览。",
      },
      {
        title: "有人陪伴",
        text: "咨询师免费陪伴交往全过程，不是只介绍一次。",
      },
    ],
    faqs: [
      {
        q: "和其他相亲网站有什么不同？",
        a: "平台配备专业婚恋咨询师，提供前期免费长期陪伴，从找对象、交往到结婚全程辅导。",
      },
      {
        q: "如何快速脱单？",
        a: "完善资料并完成测评，主动查看同城推荐，必要时预约咨询师制定交往计划。",
      },
    ],
    primaryCta: { label: "免费注册 · 开始脱单", to: "/register" },
    secondaryCta: { label: "同城找对象", to: "/discover" },
    tertiaryCta: { label: "浏览城市专题", to: "/city" },
    jsonLdTopics: ["脱单", "相亲", "找对象"],
  },
  {
    slug: "hunyin-zixun",
    badge: "婚姻咨询",
    headline: "婚姻咨询 · 婚姻修复与关系辅导",
    intro:
      "已婚或恋爱中遇到沟通、关系问题？AI婚恋平台提供婚姻咨询与关系辅导服务，注册时选择已婚身份即可进入，获得咨询师在关系修复、夫妻沟通等方面的专业支持。",
    keywords:
      "婚姻咨询,婚姻修复,夫妻关系,感情咨询,婚姻危机,夫妻沟通,婚前辅导,恋爱指导,情感咨询,婚恋咨询,关系修复",
    metaDescription:
      "婚姻咨询与婚姻修复：专业婚恋咨询师提供夫妻关系辅导、沟通改善、恋爱指导与婚前辅导，帮助修复婚姻关系、重建亲密连接。",
    ogDescription: "婚姻咨询、婚姻修复与关系辅导，专业咨询师陪伴。",
    features: [
      {
        title: "关系诊断",
        text: "通过测评与咨询了解关系现状，找到可改善的方向。",
      },
      {
        title: "沟通辅导",
        text: "咨询师帮助改善夫妻/情侣沟通模式，减少重复冲突。",
      },
      {
        title: "全程陪伴",
        text: "从恋爱到婚姻均可预约咨询师，前期陪伴免费。",
      },
    ],
    faqs: [
      {
        q: "已婚用户如何使用？",
        a: "注册时选择已婚身份，进入用户中心后可预约婚姻咨询与关系服务。",
      },
      {
        q: "和情感热线有什么不同？",
        a: "平台咨询师提供长期陪伴式辅导，而非一次性倾诉，更注重关系改善与行动方案。",
      },
    ],
    primaryCta: { label: "免费注册 · 婚姻服务", to: "/register" },
    secondaryCta: { label: "预约咨询师", to: "/consultants" },
    tertiaryCta: { label: "婚前辅导专题", to: "/topic/zixunshi" },
    jsonLdTopics: ["婚姻咨询", "婚姻修复", "夫妻关系"],
  },
  {
    slug: "zixunshi",
    badge: "婚恋咨询师",
    headline: "婚恋咨询师 · 免费陪伴到结婚",
    intro:
      "不想只被「介绍一次」？AI婚恋平台配备专业婚恋咨询师，区别于传统红娘，提供前期免费长期陪伴：从找对象、恋爱沟通到谈婚论嫁全程辅导。",
    keywords:
      "婚恋咨询师,婚姻咨询师,免费婚恋陪伴,情感咨询师,婚前辅导,恋爱指导,专业婚恋辅导,不找红娘找对象,从认识到结婚陪伴",
    metaDescription:
      "婚恋咨询师免费陪伴：区别于传统红娘介绍，专业咨询师一对一辅导找对象、恋爱与婚前准备，从相识到结婚全程陪伴，前期咨询免费。",
    ogDescription: "专业婚恋咨询师，前期免费陪伴到结婚。",
    features: [
      {
        title: "非红娘模式",
        text: "不是简单介绍，而是长期陪伴您的交往与决策过程。",
      },
      {
        title: "前期免费",
        text: "相识、恋爱阶段的咨询陪伴免费，降低试错成本。",
      },
      {
        title: "可预约入驻",
        text: "欢迎有经验的专业咨询师申请入驻平台。",
      },
    ],
    faqs: [
      {
        q: "咨询师和红娘有什么区别？",
        a: "红娘侧重介绍对象；咨询师侧重陪伴交往过程、沟通与关系决策，帮助您更稳妥地走向婚姻。",
      },
      {
        q: "如何预约咨询师？",
        a: "注册后在咨询师列表中选择合适老师，发起预约或在线咨询。",
      },
    ],
    primaryCta: { label: "查看咨询师列表", to: "/consultants" },
    secondaryCta: { label: "免费注册会员", to: "/register" },
    tertiaryCta: { label: "咨询师入驻", to: "/registerConsultants" },
    jsonLdTopics: ["婚恋咨询师", "免费婚恋陪伴", "婚前辅导"],
  },
  {
    slug: "ai-pipei",
    badge: "AI 智能匹配",
    headline: "AI婚恋 · 智能匹配找对象",
    intro:
      "希望更高效地找到合适对象？AI婚恋平台结合性格测评与智能算法，为您推荐匹配度更高的异性会员，并可配合咨询师陪伴，让相亲不止于「刷资料」。",
    keywords:
      "AI婚恋,AI相亲,AI智能匹配,智能推荐对象,性格测评找对象,婚恋测评,匹配度测试,在线相亲,智能婚恋",
    metaDescription:
      "AI婚恋与智能匹配：性格测评 + AI算法推荐合适对象，认证会员优先，配合专业咨询师免费陪伴，从测评、匹配到交往全程服务。",
    ogDescription: "AI智能匹配找对象，测评 + 推荐 + 咨询师陪伴。",
    features: [
      {
        title: "AI 测评",
        text: "完成问卷测评，了解自身偏好与交往风格。",
      },
      {
        title: "智能推荐",
        text: "系统按匹配度推荐异性，支持同城与条件筛选。",
      },
      {
        title: "人机结合",
        text: "算法推荐 + 咨询师复核建议，提高匹配质量。",
      },
    ],
    faqs: [
      {
        q: "AI 匹配准确吗？",
        a: "测评与资料多维计算匹配度，推荐结果可随资料完善与互动反馈持续优化。",
      },
      {
        q: "如何使用 AI 匹配？",
        a: "注册后完成问卷测评，在发现页查看系统推荐的异性会员。",
      },
    ],
    primaryCta: { label: "免费注册 · 开始测评", to: "/register" },
    secondaryCta: { label: "去做 AI 测评", to: "/questionnaire" },
    tertiaryCta: { label: "查看推荐会员", to: "/discover" },
    jsonLdTopics: ["AI婚恋", "AI智能匹配", "性格测评找对象"],
  },
];

export function getTopicBySlug(slug) {
  return TOPIC_SEO_LIST.find((item) => item.slug === slug) || null;
}

export function buildTopicJsonLd(topic) {
  return {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",
        name: topicSeoTitle(topic),
        description: topic.metaDescription,
        about: topic.jsonLdTopics || [],
      },
      {
        "@type": "FAQPage",
        mainEntity: (topic.faqs || []).map((item) => ({
          "@type": "Question",
          name: item.q,
          acceptedAnswer: {
            "@type": "Answer",
            text: item.a,
          },
        })),
      },
    ],
  };
}

export function topicSeoTitle(topic) {
  return `${topic.headline} - ${SITE_NAME}`;
}

export function topicSeoFromConfig(topic) {
  return {
    title: topicSeoTitle(topic),
    metaDescription: topic.metaDescription,
    ogDescription: topic.ogDescription,
    keywords: topic.keywords,
    path: `/topic/${topic.slug}`,
    jsonLd: buildTopicJsonLd(topic),
  };
}

/** 供后端 sitemap 同步的 slug 列表 */
export const TOPIC_SEO_SLUGS = TOPIC_SEO_LIST.map((item) => item.slug);
